import { render, staticRenderFns } from "./ModalPreditivas.vue?vue&type=template&id=e2634fb4&scoped=true&"
import script from "./ModalPreditivas.vue?vue&type=script&lang=js&"
export * from "./ModalPreditivas.vue?vue&type=script&lang=js&"
import style0 from "./ModalPreditivas.vue?vue&type=style&index=0&id=e2634fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2634fb4",
  null
  
)

export default component.exports